import { useContext, useEffect, useRef, useState } from "react";
import olMap from "ol/Map";
import olDrawInteraction from "ol/interaction/Draw";
import olDragPan from "ol/interaction/DragPan";
import olVectorSource from "ol/source/Vector";

import { OLParser } from "../JSTS/OL";
import MapContext from "../map/MapContext";

export interface PolygonProps {
  source: olVectorSource;
  active: boolean;
  freehand: boolean;
  onDrawEnd?: (polygon: jsts.geom.Polygon) => void;
}

export const DrawPolygon = ({
  source,
  active,
  onDrawEnd,
  freehand,
}: PolygonProps) => {
  const [interaction, setInteraction] = useState<olDrawInteraction | null>(
    null
  );
  const map = useContext(MapContext) as olMap;
  const onDrawEndRef = useRef(onDrawEnd);
  onDrawEndRef.current = onDrawEnd;

  useEffect(() => {
    if (!map) return () => {};

    const interaction = new olDrawInteraction({
      source,
      type: "Polygon",
      freehand
    });

    interaction.setActive(active);
    interaction.on("drawend", (e) => {
      if (!onDrawEndRef.current) return;
      const jstsGeom = OLParser.read(
        e.feature.getGeometry()
      ) as jsts.geom.Polygon;
      onDrawEndRef.current(jstsGeom);
    });
    map.addInteraction(interaction);
    setInteraction(interaction);

    return () => {
      if (!map) return;
      map.removeInteraction(interaction);
      setInteraction(null);
    };
  }, [map, source, freehand]);

  useEffect(() => {
    if (!interaction) return;
    interaction.setActive(active);
  }, [active]);

  useEffect(() => {
    if (!map || !freehand) return;
    map.getInteractions().forEach((i) => {
      if (i instanceof olDragPan) i.setActive(!active);
    });
    return () => {
      map.getInteractions().forEach((i) => {
        if (i instanceof olDragPan) i.setActive(true);
      });
    };
  }, [map, freehand, active]);

  return null;
};
